var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Typography } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { ApplicationContext } from '../../components/ApplicationProvider';
import { ConfigitProductContext } from '../../components/ConfigitProductProvider';
import { APU_MEASUREMENT_ATTRIBUTES } from '../../components/constants/MEASURE_UNITS';
import { Loading } from '../../components/shared/Loading/Loading';
import { SelectBox } from '../../components/shared/SelectComponent/SelectBox';
import { ConfigitTextField } from '../../components/shared/TextFieldComponent/ConfigitTextField';
import { AttributeType, ComparisonOperator } from '../../services/AssemblySearchAPIService';
import { configureLayer as configureLayerAPI } from '../../services/ConfigitService';
import theme from '../../theme';
import { ProductAttributeForm } from './ProductAttributeForm';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
export var ConfigitProductForm = function (_a) {
    var variableAssignments = _a.variableAssignments, setVariableAssignments = _a.setVariableAssignments, section = _a.section, limit = _a.limit, getVariableAt = _a.getVariableAt;
    var _section$variables;
    var _b = useState(''), selectedAPUName = _b[0], setSelectedAPUName = _b[1];
    var setLoading = useContext(ApplicationContext).setLoading;
    var _c = useContext(ConfigitProductContext), attributes = _c.attributes, setAttributes = _c.setAttributes, isAttributeSelected = _c.isAttributeSelected, setIsAttributeSelected = _c.setIsAttributeSelected, selectedApprovedUse = _c.selectedApprovedUse, setSelectedApprovedUse = _c.setSelectedApprovedUse, selectedAttributeId = _c.selectedAttributeId, setSelectedAttributeId = _c.setSelectedAttributeId;
    var attributeLoading = false;
    var nonAttributeIds = ['Manufacturer_ManufacturerId', 'ManufacturedProduct_ComponentId', 'ManufacturedProduct_CategoryId', 'CApprovedUse_ApprovedUseId', 'ManufacturedProduct_CountryId']; //    causes selection issues
    useEffect(function () {
        //     const defaultOperatorVariableAssignments = selectedApprovedUse?.variables
        //         ?.filter(
        //             (data) => data.id?.endsWith('Operator'))
        //         .map((data) => {
        //             return { variableId: data.id, value: 'Equal' } as VariableAssignment;
        //         });
        //     if (defaultOperatorVariableAssignments) {
        //         const newVariableAssignments: VariableAssignment[] = [...variableAssignments, ...defaultOperatorVariableAssignments];
        //         setVariableAssignments(newVariableAssignments);
        //     }
        // }
    }, [selectedAPUName, selectedApprovedUse]); // Selection
    var formSelect = function (variableId, value, variableAssignments, setVariableAssignments, setLoading) {
        setLoading(true);
        var newVariableAssignments = variableAssignments.filter(function (variableAssignment) { return variableAssignment.variableId !== variableId; });
        if (typeof value === 'string')
            newVariableAssignments.push({ variableId: variableId, value: value });
        else if (typeof value[0] === 'string')
            newVariableAssignments.push({ variableId: variableId, type: 'AllowedValues', allowedValues: value.map(function (val) { return { type: 'SingletonValue', value: String(val) }; }) });
        else
            newVariableAssignments.push({ variableId: variableId, type: 'AllowedValues', allowedValues: value.map(function (data) { return data; }) }); // logic for attribute changes below
        if (!nonAttributeIds.includes(variableId) && typeof value === 'string') {
            var _selectedApprovedUse$; // set flag here if man/product not selected
            var isOperator_1 = variableId.includes('Operator');
            var attributeToPush = selectedApprovedUse === null || selectedApprovedUse === void 0 ? void 0 : (_selectedApprovedUse$ = selectedApprovedUse.variables) === null || _selectedApprovedUse$ === void 0 ? void 0 : _selectedApprovedUse$.find(function (attribute) { return attribute.id === variableId; });
            var operatorValue_1 = isOperator_1 ? value : getAssignedValue(variableId + 'Operator'); // assigned by rule logic here
            if (attributeToPush && attributeToPush.properties) {
                var _attributeToPush$prop;
                var truncateAttributeName_1 = variableId.substring(variableId.indexOf('_') + 1);
                var tempAttribute = { attributeName: truncateAttributeName_1, attributeType: getAttributeType((_attributeToPush$prop = attributeToPush.properties[0]) === null || _attributeToPush$prop === void 0 ? void 0 : _attributeToPush$prop.value), attributeValue: isOperator_1 ? '' : value, comparisonOperator: isOperator_1 ? getComparisonOperator(value) : getComparisonOperator(operatorValue_1) }; // check if attribute is already include and modify instead of pushing duplicate data
                var attributeFlag_1 = false;
                attributes.forEach(function (obj) { if (isOperator_1 && obj.attributeName + 'Operator' === truncateAttributeName_1) {
                    obj.comparisonOperator = getComparisonOperator(operatorValue_1);
                    attributeFlag_1 = true;
                    return;
                } if (obj.attributeName === truncateAttributeName_1) {
                    obj.attributeValue = value;
                    obj.comparisonOperator = getComparisonOperator(operatorValue_1);
                    attributeFlag_1 = true;
                    return;
                } }); // check to see if measurement assigned by rule
                if (!attributeFlag_1 && isOperator_1) {
                    var _selectedApprovedUse$2, _find;
                    var assignedAttribute = selectedApprovedUse === null || selectedApprovedUse === void 0 ? void 0 : (_selectedApprovedUse$2 = selectedApprovedUse.variables) === null || _selectedApprovedUse$2 === void 0 ? void 0 : _selectedApprovedUse$2.find(function (attribute) { return attribute.id + 'Operator' === variableId; });
                    var assignedValue = (_find = (assignedAttribute === null || assignedAttribute === void 0 ? void 0 : assignedAttribute.values).find(function (value) { return value.assigned === 'byRule'; })) === null || _find === void 0 ? void 0 : _find.value;
                    var parentName = truncateAttributeName_1.replace('Operator', '');
                    if (assignedValue && assignedAttribute && assignedAttribute.properties) {
                        var _assignedAttribute$pr;
                        var tempAttributeByRule = { attributeName: parentName, attributeType: getAttributeType((_assignedAttribute$pr = assignedAttribute.properties[0]) === null || _assignedAttribute$pr === void 0 ? void 0 : _assignedAttribute$pr.value), attributeValue: String(assignedValue), comparisonOperator: getComparisonOperator(operatorValue_1) };
                        attributes.push(tempAttributeByRule);
                    }
                }
                if (!attributeFlag_1 && !isOperator_1)
                    attributes.push(tempAttribute); // move this code block higher up, include check to see if attribute exists
                if (selectedApprovedUse !== null && selectedApprovedUse !== void 0 && selectedApprovedUse.variables) {
                    selectedApprovedUse.variables.forEach(function (attr) {
                        var _attr$id;
                        var assignedVal = undefined;
                        if (!((_attr$id = attr.id) !== null && _attr$id !== void 0 && _attr$id.includes('view'))) {
                            var _attr$values;
                            (_attr$values = attr.values) === null || _attr$values === void 0 ? void 0 : _attr$values.forEach(function (value) { if (value.assigned === 'byRule') {
                                assignedVal = String(value.value);
                            } });
                        }
                        if (assignedVal && attr.id && attr.properties && !attr.id.includes('Operator') && !nonAttributeIds.includes(attr.id)) {
                            var _attr$properties$;
                            var truncatedAssignedName = attr.id.substring(attr.id.indexOf('_') + 1);
                            var assignedOperatorValue = getAssignedValue(variableId + 'Operator'); //   const isAssignedOperator
                            // const assignedOperatorValue
                            var assignedAttributeByRule = { attributeName: truncatedAssignedName, attributeType: getAttributeType((_attr$properties$ = attr.properties[0]) === null || _attr$properties$ === void 0 ? void 0 : _attr$properties$.value), attributeValue: assignedVal, comparisonOperator: isOperator_1 ? getComparisonOperator(assignedVal) : getComparisonOperator(assignedOperatorValue) };
                            if (!attributes.find(function (attribute) { var _attr$id2; return attribute.attributeName === ((_attr$id2 = attr.id) === null || _attr$id2 === void 0 ? void 0 : _attr$id2.substring(attr.id.indexOf('_') + 1)); })) {
                                attributes.push(assignedAttributeByRule);
                            }
                        }
                    });
                }
                setIsAttributeSelected(true);
            }
        } // remove attributes and variable assignments associated with them if new APU selected
        if (variableId == 'CApprovedUse_ApprovedUseId') {
            newVariableAssignments = newVariableAssignments.filter(function (variableAssignment) { return nonAttributeIds.includes(variableAssignment.variableId ? variableAssignment.variableId : ''); });
            setAttributes([]);
            setIsAttributeSelected(true);
        } // add in checks- this is happy path and will be error prone
        // add in check for assigned by rule
        if (selectedAttributeId)
            updateAttributeData(selectedAttributeId, newVariableAssignments);
        setVariableAssignments(newVariableAssignments);
    };
    var getSelectedData = function (dataId, selectedApprovedUse) { var _selectedApprovedUse$3, _selectedApprovedUse$4; var selectedData = (_selectedApprovedUse$3 = selectedApprovedUse.variables) === null || _selectedApprovedUse$3 === void 0 ? void 0 : (_selectedApprovedUse$4 = _selectedApprovedUse$3.find(function (attribute) { return attribute.id === dataId; })) === null || _selectedApprovedUse$4 === void 0 ? void 0 : _selectedApprovedUse$4.values; return selectedData; };
    var updateAttributeData = function (attributeValue, updatedVariableAssignments) { return __awaiter(void 0, void 0, void 0, function () {
        var getSelectedAttribute;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, configureLayerAPI(updatedVariableAssignments, "apu_".concat(attributeValue)).then(function (value) { setSelectedApprovedUse(value); return value; })];
                case 1:
                    getSelectedAttribute = _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    var getAttributeType = function (value) {
        var comparisonValue = -1; // lower case to account for difference between data from model and type in table
        switch (value === null || value === void 0 ? void 0 : value.toLowerCase()) {
            case 'boolean':
                comparisonValue = AttributeType.Boolean;
                break;
            case 'codetable':
                comparisonValue = AttributeType.CodeTable;
                break;
            case 'measurement':
                comparisonValue = AttributeType.Measurement;
                break;
            case 'text':
                comparisonValue = AttributeType.Text;
                break;
            case 'multivalue':
                comparisonValue = AttributeType.Multivalue;
                break;
            default: break;
        }
        return comparisonValue;
    };
    var getComparisonOperator = function (value) { var comparisonValue = 0; switch (value) {
        case 'Equal':
            comparisonValue = ComparisonOperator.EqualTo;
            break;
        case 'Different':
            comparisonValue = ComparisonOperator.NotEqualTo;
            break;
        case 'Bigger':
            comparisonValue = ComparisonOperator.GreaterThan;
            break;
        case 'BiggerOrEqual':
            comparisonValue = ComparisonOperator.GreaterThanOrEqual;
            break;
        case 'Less':
            comparisonValue = ComparisonOperator.LessThan;
            break;
        case 'LessOrEqual':
            comparisonValue = ComparisonOperator.LessThanOrEqual;
            break;
    } return comparisonValue; };
    var getAssignedValue = function (variableId) { var _selectedApprovedUse$5, _selectedApprovedUse$6; var selectedAPU = selectedApprovedUse === null || selectedApprovedUse === void 0 ? void 0 : (_selectedApprovedUse$5 = selectedApprovedUse.variables) === null || _selectedApprovedUse$5 === void 0 ? void 0 : (_selectedApprovedUse$6 = _selectedApprovedUse$5.find(function (attribute) { return attribute.id === variableId; })) === null || _selectedApprovedUse$6 === void 0 ? void 0 : _selectedApprovedUse$6.values; var result = 'Equal'; if (selectedAPU) {
        selectedAPU.forEach(function (obj) { if (obj.value && obj.assigned === 'byUser') {
            result = String(obj.value);
        } });
    } return result; };
    var updateUnselectAttributes = function (variableId, isOperator) { return __awaiter(void 0, void 0, void 0, function () {
        var newVariableAssignments, testSelected, updateData, tempAttributes_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    newVariableAssignments = variableAssignments.filter(function (variableAssignment) { return variableAssignment.variableId != variableId; });
                    testSelected = selectedApprovedUse;
                    return [4 /*yield*/, updateAttributeData(selectedAttributeId, newVariableAssignments)];
                case 1:
                    updateData = _a.sent();
                    if (selectedApprovedUse !== null && selectedApprovedUse !== void 0 && selectedApprovedUse.variables) { // setAttributes([])
                        tempAttributes_1 = [];
                        selectedApprovedUse.variables.forEach(function (attr) { var _attr$id3; var assignedVal = undefined; if (!((_attr$id3 = attr.id) !== null && _attr$id3 !== void 0 && _attr$id3.includes('view'))) {
                            var _attr$values2;
                            (_attr$values2 = attr.values) === null || _attr$values2 === void 0 ? void 0 : _attr$values2.forEach(function (value) { if (value.assigned) {
                                assignedVal = String(value.value);
                            } });
                        } if (assignedVal && attr.id && attr.properties && !attr.id.includes('Operator') && !nonAttributeIds.includes(attr.id)) {
                            var _attr$properties$2;
                            var truncatedAssignedName = attr.id.substring(attr.id.indexOf('_') + 1);
                            var assignedOperatorValue = getAssignedValue(variableId + 'Operator');
                            var assignedAttributeByRule = { attributeName: truncatedAssignedName, attributeType: getAttributeType((_attr$properties$2 = attr.properties[0]) === null || _attr$properties$2 === void 0 ? void 0 : _attr$properties$2.value), attributeValue: assignedVal, comparisonOperator: isOperator ? getComparisonOperator(assignedVal) : getComparisonOperator(assignedOperatorValue) };
                            if (!attributes.find(function (attribute) { var _attr$id4; return attribute.attributeName === ((_attr$id4 = attr.id) === null || _attr$id4 === void 0 ? void 0 : _attr$id4.substring(attr.id.indexOf('_') + 1)); })) {
                                tempAttributes_1.push(assignedAttributeByRule);
                            }
                        } });
                        setAttributes(tempAttributes_1);
                    }
                    if (attributes.length === 0)
                        setIsAttributeSelected(false);
                    setVariableAssignments(newVariableAssignments);
                    return [2 /*return*/];
            }
        });
    }); }; // removes previously selected value and triggers configit process
    var formUnSelect = function (variableId, variableAssignments, setVariableAssignments, setLoading) {
        setLoading(true);
        var isOperator = variableId.includes('Operator');
        var newVariableAssignments = variableAssignments.filter(function (variableAssignment) { return variableAssignment.variableId != variableId; });
        if (variableId == 'ManufacturedProduct_CategoryId') {
            newVariableAssignments = newVariableAssignments.filter(function (variableAssignment) { return variableAssignment.variableId != 'CApprovedUse_ApprovedUseId'; });
            newVariableAssignments = newVariableAssignments.filter(function (variableAssignment) { return nonAttributeIds.includes(variableAssignment.variableId ? variableAssignment.variableId : ''); }); // setAttributes([])
            //if (selectedAttributeId) updateAttributeData(selectedAttributeId, newVariableAssignments);
            // debugger
            //setVariableAssignments(newVariableAssignments);
        }
        else if (variableId == 'CApprovedUse_ApprovedUseId') {
            newVariableAssignments = newVariableAssignments.filter(function (variableAssignment) { return nonAttributeIds.includes(variableAssignment.variableId ? variableAssignment.variableId : ''); });
            setAttributes([]);
            setIsAttributeSelected(false); //if (selectedAttributeId) updateAttributeData(selectedAttributeId, newVariableAssignments);
            //setVariableAssignments(newVariableAssignments);
        }
        else { // filter out attributes, requires a truncated variableId field
            // possible fix- clear all, and if assinged by rule/user add to attributes1
            if (!nonAttributeIds.includes(variableId)) {
                var truncateAttributeName = variableId.substring(variableId.indexOf('_') + 1);
                updateUnselectAttributes(variableId, isOperator);
            }
        }
        setVariableAssignments(newVariableAssignments);
    };
    var select = function (variableId, value) { return formSelect(variableId, value, variableAssignments, setVariableAssignments, setLoading); };
    var unSelect = function (variableId) { return formUnSelect(variableId, variableAssignments, setVariableAssignments, setLoading); };
    var getAttributeData = function (attributeValue, name) { return __awaiter(void 0, void 0, void 0, function () {
        var _APU_MEASUREMENT_ATTR, selectedMeasurements, tempAssignments, tempArray_1, getSelectedAttribute;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    attributeLoading = true; // eqaul to before call
                    selectedMeasurements = (_APU_MEASUREMENT_ATTR = APU_MEASUREMENT_ATTRIBUTES.find(function (obj) { return obj.approvedUseId === attributeValue; })) === null || _APU_MEASUREMENT_ATTR === void 0 ? void 0 : _APU_MEASUREMENT_ATTR.measurementAttributes;
                    tempAssignments = variableAssignments;
                    if (selectedMeasurements) {
                        tempArray_1 = [];
                        selectedMeasurements.forEach(function (measurement) { var operatorColumnName = measurement.columnName + 'Operator'; if (!tempArray_1.find(function (obj) { return obj.variableId === operatorColumnName; })) {
                            tempArray_1.push({ variableId: operatorColumnName, value: 'Equal' });
                        } });
                        tempAssignments = __spreadArray(__spreadArray([], tempAssignments, true), tempArray_1, true);
                    }
                    return [4 /*yield*/, configureLayerAPI(tempAssignments, "apu_".concat(attributeValue))];
                case 1:
                    getSelectedAttribute = _a.sent();
                    setSelectedApprovedUse(getSelectedAttribute);
                    setSelectedAPUName(name);
                    setSelectedAttributeId(attributeValue);
                    return [2 /*return*/, selectedApprovedUse];
            }
        });
    }); };
    var assignedVals = false;
    return /*#__PURE__*/ _jsx(_Fragment, { children: (_section$variables = section.variables) === null || _section$variables === void 0 ? void 0 : _section$variables.map(function (variable, index) {
            if (limit && index === limit)
                return;
            if (getVariableAt && index !== getVariableAt)
                return;
            var id = variable.id, name = variable.name, properties = variable.properties, values = variable.values, valueType = variable.valueType;
            var last = section.variables && index === section.variables.length - 1;
            var isAuto = ['Manufacturer', 'Product', 'Country'];
            if (values && name !== 'Product subcategory') {
                var formGroup = void 0;
                var productName = 'Trade Name'; // pass ProductModel section values if attribute properties are not selected. otherwise, pass in values
                // from attribute model
                if (name && isAuto.includes(name) && !isAttributeSelected) {
                    formGroup = /*#__PURE__*/ _jsx(ConfigitTextField, { id: id, label: name.includes('Product') ? productName : name, options: values, select: select, unSelect: unSelect });
                }
                else if (name && isAuto.includes(name) && isAttributeSelected && selectedApprovedUse && selectedApprovedUse.variables) {
                    var countryValues = getSelectedData('ManufacturedProduct_CountryId', selectedApprovedUse);
                    var manufacturerValues = getSelectedData('Manufacturer_ManufacturerId', selectedApprovedUse);
                    var propertyValues = getSelectedData('ManufacturedProduct_ComponentId', selectedApprovedUse);
                    if (name.includes('Manufacturer') && manufacturerValues) {
                        formGroup = /*#__PURE__*/ _jsx(ConfigitTextField, { id: id, label: name, options: manufacturerValues, select: select, unSelect: unSelect, "data-testid": "manufacturer" });
                    }
                    if (name.includes('Product') && propertyValues) {
                        formGroup = /*#__PURE__*/ _jsx(ConfigitTextField, { id: id, label: productName, options: propertyValues, select: select, unSelect: unSelect, "data-testid": "tradename" });
                    }
                    if (name.includes('Country') && countryValues) {
                        formGroup = /*#__PURE__*/ _jsx(SelectBox, { id: id, label: name, options: countryValues, select: select, unSelect: unSelect, className: 'assembly-select as-2', "data-testid": "country" });
                    }
                }
                else if (name !== 'Product subcategory') {
                    formGroup = /*#__PURE__*/ _jsx(SelectBox, { id: id, label: name, options: values, select: select, unSelect: unSelect, className: 'assembly-select as-2' });
                }
                if (id == 'CApprovedUse_ApprovedUseId') {
                    assignedVals = false;
                    values.forEach(function (datum) { if (datum.assigned) {
                        var chosenAttributeValue = datum.value;
                        if (chosenAttributeValue) {
                            getAttributeData(String(chosenAttributeValue), datum.name);
                            assignedVals = true;
                            attributeLoading = false;
                        }
                    } });
                }
                return /*#__PURE__*/ _jsxs("div", { className: "form-group ".concat(!last && index === 0 ? 'mt-2' : '', " ").concat(last ? 'mb-0' : ''), children: [/*#__PURE__*/ _jsx("div", { className: "d-flex align-items-center", children: formGroup }), assignedVals && selectedApprovedUse && /*#__PURE__*/ _jsx("div", { className: "d-flex align-items-center pt-3", children: !attributeLoading ? /*#__PURE__*/ _jsxs("div", { children: [/*#__PURE__*/ _jsxs(Typography, { fontFamily: 'Inter', fontSize: 20, fontWeight: 500, color: theme.palette.rnSteel.steel700, className: "pb-2 pt-1", children: [selectedAPUName, " Attributes"] }), /*#__PURE__*/ _jsx(ProductAttributeForm, { attributeId: selectedAttributeId, approvedUseCode: selectedAPUName ? selectedAPUName : '', variables: selectedApprovedUse.variables, handleFormSelect: select, handleFormUnSelect: unSelect })] }) : /*#__PURE__*/ _jsx(Loading, {}) })] }, index);
            }
        }) });
};
